import(/* webpackMode: "eager" */ "/vercel/path0/src/app/releases/[id]/page.tsx");
